import { FormControl, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select';
import { cn } from '@/lib/utils';
import React from 'react';

interface SelectComponentProps {
  label: React.ReactNode;
  options: { value: string; label: string }[];
  onValueChange: (value: string) => void;
  defaultValue?: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  errorMessage?: string;
}

export const SelectComponent: React.FC<SelectComponentProps> = ({
  label,
  options,
  onValueChange,
  defaultValue,
  value,
  placeholder = 'Select an option',
  disabled,
  errorMessage
}) => {
  return (
    <FormItem>
      <FormLabel className="text-gray-800">{label}</FormLabel>
      <Select
        disabled={disabled}
        onValueChange={onValueChange}
        defaultValue={defaultValue}
        value={value}
      >
        <FormControl>
          <SelectTrigger
            className={cn('!mt-1', errorMessage && 'border-red-400 focus-visible:ring-0')}
          >
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          {options.map((option, i) => (
            <SelectItem key={i} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {errorMessage && <FormMessage className="text-xs">{errorMessage}</FormMessage>}
    </FormItem>
  );
};
